// Registry for the data-driven quiz engine. Each entry keyed by slug is consumed
// by Quiz.js (`/quiz/:slug`) and QuizResult.js (`/quiz/:slug/result/:type`).
//
// To add a future quiz: drop a new definition module in this folder and register
// it here — routing, prerender, and the hub pick it up automatically. Keep the
// build-time manifest (client/scripts/quizzes.manifest.js) in sync so the new
// quiz's pages get prerendered + added to the sitemap.
import sleep from "./sleep";
import stress from "./stress";
import gut from "./gut";
import hormones from "./hormones";
import tcmElement from "./tcm-element";
import immune from "./immune";

export const QUIZZES = {
  [sleep.slug]: sleep,
  [stress.slug]: stress,
  [gut.slug]: gut,
  [hormones.slug]: hormones,
  [tcmElement.slug]: tcmElement,
  [immune.slug]: immune,
};

export const getQuiz = (slug) => QUIZZES[slug] || null;

// Short labels for compact UI (nav dropdown).
const NAV_LABELS = {
  dosha: "Dosha Quiz",
  sleep: "Sleep",
  stress: "Stress & Burnout",
  gut: "Gut & Digestion",
  hormones: "Hormone Balance",
  "tcm-element": "Five Element Type",
  immune: "Immune Resilience",
};

// Cards for the /quizzes hub. Includes the standalone Dosha quiz (its own
// component + routes) plus every engine quiz. `path` is where the card links.
export const HUB_QUIZZES = [
  {
    slug: "dosha",
    title: "What's your Ayurvedic dosha?",
    navLabel: NAV_LABELS.dosha,
    emoji: "🧘",
    blurb: "Discover your mind-body type — Vata, Pitta, or Kapha — and balancing herbs.",
    path: "/quiz",
  },
  ...Object.values(QUIZZES).map((q) => ({
    slug: q.slug,
    title: q.title,
    navLabel: NAV_LABELS[q.slug] || q.title,
    emoji: q.emoji,
    blurb: q.blurb,
    path: `/quiz/${q.slug}`,
  })),
];

export default QUIZZES;
